export default __webpack_public_path__ + "static/media/Inter.var.aadb65ac.ttf";